import { AxiosPromise } from 'axios'
import { ICommerceProduct } from 'components/pages/CommercePage'
import { axiosInstance } from './api'

export const commerceApi = {
  postShopRequest: (data: ICommerceProduct): AxiosPromise<{ url: string }> =>
    axiosInstance.post('api_integration/shop_request/', data)
}
